import { render } from "./VoucherForm.vue?vue&type=template&id=4faf2738&scoped=true"
import script from "./VoucherForm.vue?vue&type=script&lang=js"
export * from "./VoucherForm.vue?vue&type=script&lang=js"

import "./VoucherForm.vue?vue&type=style&index=0&id=4faf2738&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faf2738"]])

export default __exports__